module.exports = __webpack_public_path__ + "img/icon-lottery-black.d90f9107.svg";